import React from 'react';
import CourseCardV2 from 'Components/CourseCardV2/CourseCardV2';
import FilterContainer from 'Containers/FilterContainer';
import LoadingContainer from 'Containers/LoadingContainer';
import type { DashboardCourseI } from 'types';
import type { MyCourseCardVM } from '../../../hooks/useMyCoursesPage';
import { ListMyCourses } from './CoursesCardGrid.styled';

export interface CoursesCardGridPropsI {
  items: MyCourseCardVM[];
  loading: boolean;
  emptyText: React.ReactNode;
  onCourseClick: (course: DashboardCourseI) => void;
}

export default function CoursesCardGrid({ items, loading, emptyText, onCourseClick }: CoursesCardGridPropsI) {
  if (items.length === 0)
    return (
      <FilterContainer>
        <LoadingContainer isLoading={loading}>{emptyText}</LoadingContainer>
      </FilterContainer>
    );

  return (
    <FilterContainer>
      <ListMyCourses>
        {items.map(item => (
          <CourseCardV2
            key={item.course.id}
            name={item.name}
            thumbnailUrl={item.thumbnailUrl}
            modulesText={item.modulesText}
            dueText={item.dueText}
            description={item.description}
            status={item.status}
            category={item.category}
            creator={item.creator}
            onClick={() => onCourseClick(item.course)}
          />
        ))}
      </ListMyCourses>
    </FilterContainer>
  );
}
